import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledTypography = styled(Typography)(() => ({
  fontSize: '32px',
  fontWeight: 300,
  marginTop: '54px',
  marginBottom: '32px',
}));

export default StyledTypography;
